import { parseCurrency } from '@/lib/utils'

// `counted` is the florist's typed count; `expected` is API money.
export function calculateCashDifferenceCents(counted: number | string, expected: number | string) {
  return Math.round(Number(counted || 0) * 100) - Math.round(parseCurrency(expected) * 100)
}

export function calculateCashDepositCents(counted: number | string, retained: number | string) {
  return Math.round(Number(counted || 0) * 100) - Math.round(Number(retained || 0) * 100)
}
